<template>
  <div class="page_content employer-container">

	<div class="row page-heading">
		<div class="col-7 input module_heading" role="heading" aria-level="1">
			<div class="module_icon ico-employer"></div>
			<label class="head_txt module_type_name">{{employer.title}}</label>
		</div>
		<div class="col-5 float-right px-0">
			<div class="btn-container">

			</div>
		</div>
	</div>

	<b-row class="page-content-section row">

		<div class="left-side">
		  <employer-menu :uuid="uuid" active="home"></employer-menu>
		</div><!-- col-3 -->

		<div class="right-panel">

      <!--
			<div class="right-nav">Home</div>
      -->

			<div class="content-row">
				<div class="subheading">
					About
				</div>
				<div class="pg_content_block">
					<div v-html="employer.description">
					</div>

					<div class="row column-row">
						<div class="col-4 column-content">
							<span class="icon-link col-left"></span>
							<span class="col-right long_url">
                <a :href="employer.externalUrl" :title="employer.externalUrl" target="_blank">{{employer.externalUrl}}</a>
              </span>
						</div>
						<div class="col-4 column-content">
							<span class="col-left"><strong>Phone:</strong> </span>
							<span class="col-right">{{employer.contactPhone}}</span>
						</div>
						<div class="col-4 column-content">
							<span class="col-left"><strong>Email:</strong> </span>
							<span class="col-right">{{employer.contactEmail}}</span>
						</div>
					</div>
				</div>


				<div class="subheading">
					Mission
				</div>
				<div class="pg_content_block">
					<p>{{employer.mission}}</p>
				</div>


				<div class="subheading">
					Job Opportunities
				</div>
				<div class="pg_content_block" style="float: left; width: 100%;">
					<div class="row column-row" style="float: left; width: 100%;">
						<div class="column-content" style="float: left; width: 100%;">

							<b-col v-for="(value, key) in categories" cols="12" class="content-set" style="float: left;">
								<p><b-link :to="{ name: 'employerCategory', params: { uuid: uuid, category: key } }">{{key}}</b-link></p>
								<ul>
									<li v-for="job in value">{{job.title}}</li>
								</ul>
							</b-col>

						</div>
					</div>
				</div>

			</div>
	   </div> <!-- col-9 -->
   </b-row> <!-- row -->
  </div>
</template>

<script>
import '../../../assets/module/css/employer/employerHome.min.css'
import { mapState, mapActions } from 'vuex'
import EmployerMenu from './EmployerMenu'
import JobResult from './JobResult'

export default {
  name: 'employerHome',
  props: ['uuid'],
  components: {
    EmployerMenu,
    JobResult
  },
  data: () => {
    return {
    }
  },

  mounted () {
    this.loadEmployer()
  },

  updated () {
  },

  methods: {
    ...mapActions([
      'loadEmployerDetail',
      'loadAllJobs'
    ]),

    loadEmployer () {
      this.loadEmployerDetail(this.uuid)
      this.loadAllJobs(this.uuid)
    }

  },

  computed: {
    ...mapState({
      'employer': state => state.employer.employer,
      'categories': state => state.employer.categories
    })
  },

  watch: {
  }
}
</script>
<style>
.margin-top-10 {
  margin-top: 10px;
}
.margin-top-20 {
  margin-top: 20px;
}
.margin-top-30 {
  margin-top: 30px;
}
.no-border {
  border: none;
}
.margin-left-20 {
  margin-left: 20px;
}
</style>



// WEBPACK FOOTER //
// src/app/employer/components/EmployerHome.vue